export default function LabelContainer({ children, label, placeholder, className = '', fill = false }) {
    return (
        <div className={`label-container ${className}`} style={{ width: fill ? '100%' : 'inherit' }}>
            { (label || placeholder) && <label className="text-sm text-gray-500">{ label || placeholder }</label> }
            { children }
        </div>
    )
}